import * as z from "zod";

export const deleteWarehouseProduct = {
  name: "deleteWarehouseProduct" as const,
  input: z.object({ productId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
